import React from 'react';
import PropTypes from 'prop-types';

import Timer from './Timer';

const BarcodeItem = (props) => (
    <div className="digital-barcode-content">
        <div className="barcode-wrapper">
            <p>{props.merchantName}</p>
            <div className="barcode" id="barcode">
                {props.encryptedBarCode}
            </div>
            <p>{props.barcode}</p>
        </div>
        <Timer handleClose={props.handleClose} />
    </div>
);

BarcodeItem.propTypes = {
    barcode: PropTypes.string.isRequired,
    encryptedBarCode: PropTypes.string.isRequired,
    handleClose: PropTypes.func.isRequired,
    merchantName: PropTypes.string.isRequired,
};

export default BarcodeItem;
